import styled from 'styled-components';

export const SummaryContainer = styled.div`
  margin-top: 24px;
  padding-bottom: 20px;
`;

export const SummaryBox = styled.div`
  background: #ededed;
  padding: 35px 20px 35px 20px;
  border-radius: 0;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 10px;
    background-image: radial-gradient(
      circle at 10px 0px,
      white 10px,
      #ededed 10px
    );
    background-size: 20px 20px;
    background-position: 0 0;
    background-repeat: repeat-x;
  }

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 10px;
    background-image: radial-gradient(
      circle at 10px 10px,
      white 10px,
      #ededed 10px
    );
    background-size: 20px 20px;
    background-position: 0 0;
    background-repeat: repeat-x;
  }
`;

export const SummaryItem = styled.div`
  background: white;
  padding: 12px;
  border-radius: 6px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  font-weight: bold;
  color: #4b5563;
`;

export const Divider = styled.div`
  border: none;
  border-top: 2px dashed #9ca3af;
  margin: 20px 0;
  position: relative;

  &::before {
    content: 'Destacar aqui';
    position: absolute;
    left: 50%;
    top: -10px;
    transform: translateX(-50%);
    font-size: 11px;
    color: #9ca3af;
    background: #ededed;
    padding: 0 10px;
    font-weight: 600;
    letter-spacing: 0.5px;
  }

  &::after {
    content: '✂';
    position: absolute;
    right: 10px;
    top: -12px;
    font-size: 20px;
    color: #6b7280;
    background: #ededed;
    padding: 0 5px;
  }
`;

export const TotalRow = styled.div`
  display: flex;
  justify-content: space-between;
  font-weight: bold;
  color: #000;
`;
